import api from '../token';

export const AddConta = async (dados) => {
  try {
    const response = await api.post('/addConta', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};